import Alpine from "alpinejs";
import * as utils from "../../editor/v2/utils/sharedUtils";
import * as uiUtils from "../../editor/v2/utils/uiUtils";

Alpine.data("contactForm", () => ({
    uuid: null,

    placeholderClass: '',

    buttonStyles: '',
    buttonHoverStyles: '',

    configuration: {
        fields: {
            name: { enabled: true, label: 'Name', placeholder: 'Enter your name...'},
            email: { enabled: true, label: 'Email', placeholder: 'Enter your email...' },
            phone: { enabled: false, label: 'Phone', placeholder: 'Enter your phone...' },
            fileUpload: { enabled: false, label: 'Upload', placeholder: '' },
            subject: { enabled: true, label: 'Subject', placeholder: 'Enter the subject...' },
            message: { enabled: true, label: 'Message', placeholder: 'Write your message...' },
            submit: { label: 'Send'}
        },
        styles: {
            form: {
                gap: ''
            },
            labels: {
                color: '',
                textSize: '',
                paddings: {
                    top: '',
                    bottom: '',
                    left: '',
                    right: ''
                }
            },
            fields: {
                color: '',
                textSize: '',
                paddings: {
                    top: '',
                    bottom: '',
                    left: '',
                    right: ''
                },
                borderRadius: {
                    topLeft: '',
                    topRight: '',
                    bottomLeft: '',
                    bottomRight: ''
                }
            },
            buttons: {
                color: utils.createColors(),
                backgroundStyle: utils.createBackgroundStyles(),
                textSize: '',
                paddings: {
                    top: '',
                    bottom: '',
                    left: '',
                    right: ''
                },
                borderRadius: {
                    topLeft: '',
                    topRight: '',
                    bottomLeft: '',
                    bottomRight: ''
                }
            }
        }
    },

    formData: {
        email: '',
        subject: '',
        phone: '',
        token: '',
        message: '',
        mailTo: '',
        name: '',
        rootPath: ''
    },
    formMessage: '',
    heading: '',
    formSuccess: false,
    formError: false,
    requestCompleted: false,

    init(uuid, configuration) {
        if (configuration) {
            this.configuration = configuration;
            this.formData.mailTo = this.configuration.fields.submit.recipientEmail;
            this.changeButtonsBackgroundStyles();
        }
        if (uuid) {
            this.uuid = uuid;
        }

        // Attach a message listener to reinitialize sliders dynamically
        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-contactForm') {
                let json = JSON.parse(event.data.data);

                if (json.id === this.uuid) {
                    this.configuration = json.configuration;
                    this.changeButtonsBackgroundStyles();
                    this.placeholderClass = 'placeholder-[' + this.configuration.styles.fields.color + ']';
                }
            }
        });
    },

    changeButtonsBackgroundStyles() {
        this.buttonStyles = '';
        this.buttonHoverStyles = '';

        const backgroundStyle = this.configuration.styles.buttons.backgroundStyle;
        const color = this.configuration.styles.buttons.color;
        const paddings = this.configuration.styles.buttons.paddings;
        const borderRadius = this.configuration.styles.buttons.borderRadius;

        if (backgroundStyle.normal.backgroundType === 'color') {
            this.buttonStyles = this.buttonStyles + ` background: ${backgroundStyle.normal.color};`;
        } else {
            this.buttonStyles = this.buttonStyles + ' ' + uiUtils.previewNormalStyle(backgroundStyle) + ';';
        }

        if (backgroundStyle.hover.backgroundType === 'color') {
            if (backgroundStyle.hover.color) {
                this.buttonHoverStyles = this.buttonHoverStyles + ` background: ${backgroundStyle.hover.color};`;
            } else {
                this.buttonHoverStyles = this.buttonHoverStyles + ' ' + this.buttonStyles;
            }
        } else {
            this.buttonHoverStyles = this.buttonHoverStyles + ' ' + uiUtils.previewHoverStyle(backgroundStyle) + ';';
        }


        this.buttonStyles = this.buttonStyles + ` color: ${color.normal};`;
        this.buttonHoverStyles = this.buttonHoverStyles + ` color: ${color.hover || color.normal};`;

        this.buttonStyles = this.buttonStyles + ` font-size: ${this.configuration.styles.buttons.textSize}px;`;
        this.buttonHoverStyles = this.buttonHoverStyles + ` font-size: ${this.configuration.styles.buttons.textSize}px;`;

        this.buttonStyles = this.buttonStyles + `padding: ${paddings.top}px ${paddings.right}px ${paddings.bottom}px ${paddings.left}px;`
        this.buttonHoverStyles = this.buttonHoverStyles + `padding: ${paddings.top}px ${paddings.right}px ${paddings.bottom}px ${paddings.left}px;`

        this.buttonStyles = this.buttonStyles + `border-radius: ${borderRadius.topLeft}px ${borderRadius.topRight}px ${borderRadius.bottomRight}px ${borderRadius.bottomLeft}px;`
        this.buttonHoverStyles = this.buttonHoverStyles + `border-radius: ${borderRadius.topLeft}px ${borderRadius.topRight}px ${borderRadius.bottomRight}px ${borderRadius.bottomLeft}px;`
    },

    submitData(endpoint, recaptchaSiteKey, rootPath) {
        this.formData.rootPath = rootPath;
        this.requestCompleted = false;
        this.formSuccess = false;
        this.formError = false;
        this.formMessage = '';
        this.heading = '';

        grecaptcha.ready(() => {
            grecaptcha.execute(recaptchaSiteKey, { action: 'defaultContact' }).then(async (token) => {
                this.formData.token = token;
                fetch(endpoint, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(this.formData)
                }).then(response => response.json())
                    .then(data => {
                        this.requestCompleted = true;
                        this.formMessage = data.message;
                        this.heading = data.heading;
                        data.statusCode < 322 ? this.formSuccess = true : this.formError = true;
                    });

            })
        })
    }
}));
